import script from "./ChildCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChildCard.vue?vue&type=script&setup=true&lang=js"

import "./ChildCard.vue?vue&type=style&index=0&id=5a2a4494&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a2a4494"]])

export default __exports__